import { trackAnalyticsEvent } from './event-trigger';
import { AnalyticsCategories } from './types';

export function trackScroll() {
  if (typeof window === 'undefined') {
    return;
  }

  const triggeredMilestones = new Set<number>();

  window.addEventListener('scroll', () => {
    const totalScrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolledPercentage = Math.round((window.scrollY / totalScrollableHeight) * 100);

    for (const milestone of [25, 50, 75, 100]) {
      if (scrolledPercentage >= milestone && !triggeredMilestones.has(milestone)) {
        trackAnalyticsEvent({
          eventCategory: AnalyticsCategories.ScrollDepth,
          eventAction: window.location.toString(),
          eventLabel: `${milestone}%`,
        });
        triggeredMilestones.add(milestone);
      }
    }
  });
}
